import { HTMLAttributes, FC, useState } from 'react';
import cx from 'classnames';
import { Icon } from '@legacy/components/ui-components/Icon';
import styles from '../../Navigation.module.scss';

interface MobileNavTreeToggleProps extends HTMLAttributes<HTMLButtonElement> {
  id: string;
  name: string;
  initialOpen?: boolean;
}

export const MobileNavTreeToggle: FC<MobileNavTreeToggleProps> = ({
  id,
  name,
  initialOpen = false,
  ...props
}) => {
  const [isActive, setIsActive] = useState(initialOpen);

  return (
    <button
      type="button"
      aria-controls={id}
      aria-expanded={isActive}
      className={cx(styles.TriggerSubNavButton, {
        [styles.TriggerSubNavButtonIsActive]: isActive,
      })}
      onClick={() => setIsActive((prev) => !prev)}
      {...props}
    >
      {name}
      <Icon iconName="pointDown" />
    </button>
  );
};
